import {v4 as uuidv4} from "uuid";

export class TimeInterval {
  constructor(
    public id: string = uuidv4(),
    public tsStart = new Date().toISOString(),
    public tsEnd =  new Date().toISOString(),
    public ticketCategory = ''
  ) {
  }
}
